 export const hostInfo = "https://ipoblog.corepix.in/ibab";
//export const hostInfo = "http://localhost:5000";